module.exports = __webpack_public_path__ + "img/aomen5.09b019ab.jpg";